import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store/index.js'
import router from '../routes'

// 根据运行模式，增加前缀
let baseUrl = process.env.BASE_API
const service = axios.create({
  baseURL: baseUrl,
  // timeout: 5000
  timeout: 60000
})
// 请求拦截
service.interceptors.request.use(
  config => {
    config.url = store.state.moduleUrl + config.url
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code == 404) {
      router.push({ path: '/home' });
      return
    }
    if ((store.state.login && !res.success && res.code == 401 && res.message == 'SESSION_INVALID') || res.code == 9999) {

      store.commit('SET_LOGIN', false);
      let msg = '登录超时，请重新登录!';
      if (res.code !== 9999) {
        Message({
          message: msg,
          type: 'warning',
          duration: 5 * 1000
        })
      }

      if (store.state.permissUpdateFlag) {
        router.go(0);
      } else {
        router.push({ path: '/login' });
      }

      return Promise.reject(new Error(res.message || msg))
    }

    if (res.code !== 200 && res.code !== "200") {
      Message({
        message: res.message || res.msg || '与服务器的连接可能中断，请尝试重新连接',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || '与服务器的连接可能中断，请尝试重新连接'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // ebug
    if (store.state.login) {
      Message({
        message: '与服务器的连接可能中断，请尝试重新连接',
        type: 'error',
        showClose: true,
        duration: 5 * 1000
      });
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/common/request.js